export const locale = {
  emptyMainSeriesPointsError: 'There is no data for the selected chart parameters',
};
